var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValetShine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "valet-shine_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#valet-shine_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 8.333H9L5 20.167V35h3.889v-3.445H31.11V35H35V20.78h-2.778v7.998H7.778v-8.611H19v-2.778H8.861l2.111-6.278H19V8.333Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.77 26.153c-.448.454-1.004.68-1.665.68a2.334 2.334 0 0 1-1.688-.673c-.463-.45-.695-1.005-.695-1.667 0-.661.232-1.224.697-1.687a2.307 2.307 0 0 1 1.692-.695c.648 0 1.2.232 1.653.697.454.464.68 1.028.68 1.692 0 .648-.224 1.199-.673 1.653ZM29.609 26.153a2.332 2.332 0 0 1-1.692.68c-.648 0-1.2-.224-1.653-.673-.454-.45-.68-1.005-.68-1.667 0-.661.224-1.224.673-1.687.449-.463 1.004-.695 1.666-.695.662 0 1.225.232 1.688.697.463.464.694 1.028.694 1.692 0 .648-.232 1.199-.696 1.653ZM27.889 20.777c0-2.478.862-4.579 2.586-6.302 1.724-1.724 3.824-2.586 6.303-2.586-2.479 0-4.58-.862-6.303-2.586C28.75 7.579 27.889 5.478 27.889 3c0 2.478-.862 4.579-2.586 6.303-1.724 1.724-3.825 2.586-6.303 2.586 2.478 0 4.579.862 6.303 2.586 1.724 1.723 2.586 3.824 2.586 6.303Z"
}))));
export default SvgValetShine;